import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import DeliveriesForm from "./DeliveriesForm";

export default function VoucherAddDialog({
  open = false,
  update = [],
  onClose = () => {},
  onAdd = () => {},
}) {
  const auth = useSelector((state) => state?.auth ?? {});
  const [data, setData] = useState({});

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setData({});
    onClose();
  };

  useMemo(() => {
    setData((prev) => ({ ...prev, email: auth?.user?.email ?? "" }));
    //eslint-disable-next-line
  }, [auth]);

  useEffect(() => {
    if (update.length)
      setData({
        box_count: update?.count,
        recipient: update.email ? true : false,
        optional_email: update?.email,
        email: update?.email,
        id: update?.id,
      });
  }, [update]);
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        elevation: 0,
        sx: { background: "#003657", borderRadius: "1.5rem" },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="font-railroad italic"
        color="white"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        X
      </IconButton>
      <DialogContent>
        <DeliveriesForm
          data={data}
          onChange={handleChange}
          onClose={handleClose}
          onAdd={onAdd} // with update
        />
      </DialogContent>
    </Dialog>
  );
}
